import useSWR from 'swr';
import { TestPagePayload } from '../../client/appTypings';
import promiseWithTimeout from '../../client/utils/promiseWithTimeout';
import { logger } from '../../common/logger';

export function useFetchTestMedia() {
  const { data, isLoading } = useSWR('test-media', fetchTestMedia);

  return {
    isLoading,
    data,
  };
}

async function fetchTestMedia() {
  try {
    const response = await promiseWithTimeout(
      fetch(testsUri, { mode: 'no-cors' }),
      2500,
      new Error('request timed out')
    );

    const { data } = (await response.json()) as TestPagePayload;
    return data;
  } catch (e) {
    return logger.debug({ error: e }, 'Fetching test media failed');
  }
}

const testsUri =
  'https://smarttv.cdn.yle.fi/prod/smarttv-testpage-content.json';
